import { Injectable, inject } from "@angular/core";
import { ConstructAPI } from "src/app/API/constructAPI";
import { RestApiService } from "src/app/API/restapi";
import { IAPILoanGroup, LoanGroup } from "src/model/loanGroup.model";
import { map } from "rxjs/operators";

export interface TxLoanGroupOptions {
  ids?: number[];
  hasOverrideCommissionRateLimit?: boolean;
  showUninvolved?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class LoanGroupAdapter {
  adapt(item: any): LoanGroup {
    return new LoanGroup(
      item.commissionRateLimit,
      item.createdOn,
      item.createdBy,
      item.id,
      item.initialCommissionRateLimit,
      item.updateRemark,
      item.overrideCommissionRateLimit,
      item.formjId,
    );
  }

  toApiModel(lg: LoanGroup): IAPILoanGroup {
    return {
      overrideCommissionRateLimit: lg.OverrideCommissionRateLimit,
      updateRemark: lg.UpdateRemark,
    };
  }
}

@Injectable({
  providedIn: "root",
})
export class LoanGroupService {
  private api = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private adapter = inject(LoanGroupAdapter);

  getSingleLoanGroup(id: number, showUninvolved?: boolean): Promise<LoanGroup> {
    return new Promise<LoanGroup>((resolve, reject) => {
      this.api
        .get<LoanGroup>(this.constructApi.getLoanGroupById(id, showUninvolved))
        .subscribe({
          next: (response) => {
            resolve(this.adapter.adapt(response));
          },
          error: (err) => {
            this.api.handleError(err);
            console.error("Failed to get loangroup: ", err);
            reject(err);
          },
        });
    });
  }

  getLoanGroups(o?: TxLoanGroupOptions): Promise<LoanGroup[]> {
    return new Promise<LoanGroup[]>((resolve, reject) => {
      this.api
        .get<LoanGroup[]>(
          this.constructApi.getLoanGroups(
            o?.ids,
            o?.hasOverrideCommissionRateLimit,
            o?.showUninvolved,
          ),
        )
        .pipe(map((data) => data.map((d) => this.adapter.adapt(d))))
        .subscribe({
          next: (response) => resolve(response),
          error: (err) => {
            this.api.handleError(err);
            console.error(err);
            reject(err);
          },
        });
    });
  }

  getOverrideLgCommRateLimit(loanGroup: LoanGroup) {
    return new Promise<LoanGroup>((resolve, reject) => {
      this.api
        .patch<LoanGroup>(
          this.constructApi.getOverrideLoanGroupCommLimit(loanGroup.Id),
          this.adapter.toApiModel(loanGroup),
        )
        .subscribe({
          next: (response) => {
            resolve(this.adapter.adapt(response));
          },
          error: (err) => {
            this.api.handleError(err);
            console.error(
              "Failed to override commission rate limit for this loan group: ",
              err,
            );
            reject(err);
          },
        });
    });
  }
}
